import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';

import { User } from '@models';
import { Store } from '@ngrx/store';
import { UserService } from '@services';
import { AppState } from '@store';
import { catchError, firstValueFrom, map, take } from 'rxjs';

export const userResolver: ResolveFn<Nullable<User>> = async (route) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const store: Store<AppState> = inject(Store);

  const { id } = route.params;

  return firstValueFrom(
    userService.getUser(id).pipe(
      catchError(() =>
        store
          .select((state) => state.auth.isLoggedIn)
          .pipe(
            take(1),
            map((isLoggedIn) =>
              isLoggedIn ? new RedirectCommand(router.parseUrl('/404')) : null
            )
          )
      )
    )
  );
};
